import { Link } from "react-router-dom";
import Stars from "./Stars";
import EuLabelRow from "./EuLabelRow";
import { useCart } from "../context/CartContext";
import { ShoppingCart, Truck } from "lucide-react";

const TyreCard = ({ tyre }) => {
  const { addItem } = useCart();
  const sizeStr = `${tyre.size.width}/${tyre.size.profile} R${tyre.size.rim}`;
  const inStock = (tyre.stock ?? 0) > 0;

  return (
    <article className="vd-card overflow-hidden flex flex-col vd-tyre-card" data-testid={`tyre-card-${tyre.id}`}>
      <Link to={`/tyres/${tyre.id}`} className="block relative">
        <div className="aspect-[4/3] overflow-hidden" style={{ background: "var(--bg-secondary)" }}>
          <img src={tyre.image} alt={`${tyre.brand} ${tyre.model}`} className="w-full h-full object-cover transition-transform duration-300 hover:scale-105" />
        </div>
        {/* Red glow streak under the tyre image — matches mockup IMG_9603 */}
        <span className="vd-tyre-card-glow" aria-hidden="true" />
      </Link>
      <div className="p-5 flex flex-col flex-1">
        <span className="vd-muted text-xs uppercase tracking-wider">{tyre.brand}</span>
        <Link to={`/tyres/${tyre.id}`} className="vd-heading font-semibold mt-1 hover:opacity-80" style={{ fontSize: 17 }} data-testid={`tyre-name-${tyre.id}`}>
          {tyre.model}
        </Link>
        <p className="vd-muted text-sm mt-1">{sizeStr} · {tyre.season} · {tyre.load_index}{tyre.speed_rating}</p>
        <div className="flex items-center gap-2 mt-2">
          <Stars value={tyre.rating} size={14} />
          <span className="vd-muted text-xs">{tyre.rating.toFixed(1)}</span>
        </div>
        <EuLabelRow tyre={tyre} testid={`eu-row-${tyre.id}`} />
        <div className="flex items-baseline justify-between mt-3">
          <span className="font-extrabold" style={{ color: "var(--primary-red)", fontSize: 22 }} data-testid={`tyre-price-${tyre.id}`}>£{tyre.price.toFixed(2)}</span>
          <span
            className="text-xs font-semibold"
            style={{ color: inStock ? "#00A35C" : "var(--text-muted)" }}
            data-testid={`stock-${tyre.id}`}
          >{inStock ? `In stock · ${tyre.stock}` : "Out of stock"}</span>
        </div>
        <div className="flex items-center gap-1.5 mt-1 mb-4" data-testid={`delivery-${tyre.id}`}>
          <Truck size={12} color="var(--primary-red)" />
          <span className="vd-muted text-xs">Next-day UK delivery available</span>
        </div>
        <div className="flex flex-col gap-2 mt-auto">
          <button
            onClick={() => addItem({ tyre_id: tyre.id, name: `${tyre.brand} ${tyre.model} ${sizeStr}`, price: tyre.price, image: tyre.image })}
            className="vd-btn-primary justify-center"
            data-testid={`add-to-basket-${tyre.id}`}
          >
            <ShoppingCart size={16} /> Add to Basket
          </button>
          <Link to="/mobile-fitting" className="vd-btn-secondary justify-center" data-testid={`book-fitting-${tyre.id}`}>Book Fitting</Link>
        </div>
      </div>
    </article>
  );
};

export default TyreCard;
